import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { EpButtonStyle, EpShellService, EpEventService, IEpRadioButtonData } from '@epicor/kinetic';
import { CustomEvents, SearchPageNames } from 'ep-bt-controls';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';
import { EpbtFaDocumentService } from '../../services/epbt-fa-document.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-sort-control',
  templateUrl: './epbt-fa-sort-control.component.html',
  styleUrls: ['./epbt-fa-sort-control.component.scss']
})
export class EpbtFaSortControlComponent implements OnChanges, OnInit {

  public orderDirectionData: Array<IEpRadioButtonData> = [{ value: 0, label: 'Ascending' },
  { value: 1, label: 'Descending' }];

  EpButtonStyle = EpButtonStyle;
  // @Input() dropdownData: EpbtFaDropdownModel;
  selectedDropdownValue: string;
  labelText = 'Sort By';
  @Input() pageName: string;
  selectedOrderDirection: number;

  constructor(private formBuilder: FormBuilder, public sortService: EpbtFaSortService,
    public filterService: EpbtFaFilterService, private epShellService: EpShellService,
    private eventService: EpEventService, private faDocumentService: EpbtFaDocumentService) { }


  ngOnChanges(changes: SimpleChanges) {
    const pageName: SimpleChange = changes.pageName;
    if (pageName) {
      this.pageName = pageName.currentValue;
      this.setDefaultOrSelectedValues();
    }
  }

  ngOnInit() {
    // console.log("data = ", this.dropdownData);
    console.log('model = ', this.epShellService.model);
    console.log('getModel = ', this.epShellService.getModel());
    this.setDefaultOrSelectedValues();
  }

  onCancelSort() {
    this.epShellService.collapseSlidingPanel();
  }

  onSortSubmit() {
    this.sortService.isFromSorting = true;
    switch (this.sortService.currentPageName) {
      case SearchPageNames.CustomerSearch: {
          this.sortService.customerSortValue = this.selectedDropdownValue;
          this.sortService.customerDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.CustomerSearch, "");
          break;
        }
      case SearchPageNames.CustomerDetailsSearch: { break; }
      case SearchPageNames.ProductSearch: {
          this.sortService.productSortValue = this.selectedDropdownValue == 'Bestmatch' ? '' : this.selectedDropdownValue;
          this.sortService.productDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.ProductSearch, "");
          break;
        }
      case SearchPageNames.ProductDetailsSearch: { break; }
      case SearchPageNames.BinLocationProductSearch: { break; }
      case SearchPageNames.SuppliersSearch: {
          this.sortService.supplierSortValue = this.selectedDropdownValue;
          this.sortService.supplierDirectionValue = this.selectedOrderDirection;
          break;
        }
      case SearchPageNames.CustomerAddressSearch: {
          this.sortService.customerAddressSortValue = this.selectedDropdownValue;
          this.sortService.customerAddressDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.CustomerAddressSearch, "");
          break;
        }
      case SearchPageNames.DashboardContactSearch: {
          this.sortService.dashboardConatctSortValue = this.selectedDropdownValue;
          this.sortService.dashboardConatctDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.DashboardContactSearch, "");
          break;
        }
      case SearchPageNames.CustomerContactSearch: {
          this.sortService.customerConatctSortValue = this.selectedDropdownValue;
          this.sortService.customerConatctDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.CustomerContactSearch, "");
          break;
        }
      case SearchPageNames.DashboardDocumentsSearch: { break; }
      case SearchPageNames.CustomerNotepad: {
          this.sortService.customerNotepadSortValue = this.selectedDropdownValue;
          this.sortService.customerNotepadDirectionValue = this.selectedOrderDirection;
          //  this.eventService.broadcast(CustomEvents.CustomerNotepadSearch, "");
          break;
        }
      case SearchPageNames.DashboardNotepadSearch: {
          this.sortService.dashboardNotepadSortValue = this.selectedDropdownValue;
          this.sortService.dashboardNotepadDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.NotepadDashboardSearch, "");
          break;
        }
      case SearchPageNames.DashboardAddressSearch: {
          this.sortService.dashboardAddressSortValue = this.selectedDropdownValue;
          this.sortService.dashboardAddressDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.DashboardAddressSearch, "");
          break;
        }
      case SearchPageNames.CustomerProductsPurchased: {
          this.sortService.customerProductsPurchasedSortValue = this.selectedDropdownValue;
          this.sortService.customerProductsPurchasedDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.CustomerProductsPurchasedSearch, "");
          break;
        }
      case SearchPageNames.CustomerOpportunity: {
          this.sortService.customerOpportunitySortValue = this.selectedDropdownValue;
          this.sortService.customerOpportunityDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, "");
          break;
        }
      case SearchPageNames.DashboardOpportunitySearch: {
          this.sortService.dashboardOpportunitySortValue = this.selectedDropdownValue;
          this.sortService.dashboardOpportunityDirectionValue = this.selectedOrderDirection;
          // this.eventService.broadcast(CustomEvents.DashboardOpportunitySearch, "");
          break;
        }
      case SearchPageNames.CustomerOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.sortService.dashboardOrderSortValue = this.selectedDropdownValue;
            this.sortService.dashboardOrderDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.DashboardDocumentSearch, "");
          } else {
            this.sortService.customerOrderSortValue = this.selectedDropdownValue;
            this.sortService.customerOrderDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, "");
          }
          break;
        }
      case SearchPageNames.CustomerQuotes: {
          if (this.faDocumentService.fromDashbard) {
            this.sortService.dashboardQuoteSortValue = this.selectedDropdownValue;
            this.sortService.dashboardQuoteDirectionValue = this.selectedOrderDirection;
            //  this.eventService.broadcast(CustomEvents.DashboardDocumentSearch, "");
          } else {
            this.sortService.customerQuoteSortValue = this.selectedDropdownValue;
            this.sortService.customerQuoteDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, "");
          }
          break;
        }
      case SearchPageNames.CustomerTempOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.sortService.dashboardTempOrderSortValue = this.selectedDropdownValue;
            this.sortService.dashboardTempOrderDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.DashboardDocumentSearch, "");
          } else {
            this.sortService.customerTempOrderSortValue = this.selectedDropdownValue;
            this.sortService.customerTempOrderDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, "");
          }
          break;
        }
      case SearchPageNames.CustomerCredit: {
          if (this.faDocumentService.fromDashbard) {
            this.sortService.dashboardCreditSortValue = this.selectedDropdownValue;
            this.sortService.dashboardCreditDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.DashboardDocumentSearch, "");
          } else {
            this.sortService.customerCreditSortValue = this.selectedDropdownValue;
            this.sortService.customerCreditDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, "");
          }
          break;
        }
      case SearchPageNames.CustomerInvoices: {
          if (this.faDocumentService.fromDashbard) {
            this.sortService.dashboardInvoicesSortValue = this.selectedDropdownValue;
            this.sortService.dashboardInvoicesDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.DashboardDocumentSearch, "");
          } else {
            this.sortService.customerInvoicesSortValue = this.selectedDropdownValue;
            this.sortService.customerInvoicesDirectionValue = this.selectedOrderDirection;
            //  this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, "");
          }
          break;
        }
      case SearchPageNames.CustomerStatements: {
          if (this.faDocumentService.fromDashbard) {
            this.sortService.dashboardStatementSortValue = this.selectedDropdownValue;
            this.sortService.dashboardStatementDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.DashboardDocumentSearch, "StatementSort");
          } else {
            this.sortService.customerStatementSortValue = this.selectedDropdownValue;
            this.sortService.customerStatementDirectionValue = this.selectedOrderDirection;
            // this.eventService.broadcast(CustomEvents.CustomerDocumentSearch, "StatementSort");
          }
          break;
        }
      case SearchPageNames.DashboardStockTranferSearch: {
          this.sortService.dashboardStockSortValue = this.selectedDropdownValue;
          this.sortService.dashboardStockDirectionValue = this.selectedOrderDirection;
          //  this.eventService.broadcast(CustomEvents.DashboardDocumentSearch, "");
          break;
        }
      default: { break; }
    }
    // this.onCancelSort();
  }

  onSortValueChange(selectedValue: any): void {
    if (selectedValue) {
      this.selectedDropdownValue = selectedValue.value;
      console.log(this.selectedDropdownValue);
    }
  }

  onOrderDirectionChange(event: any) {
    // console.log("onOrderDirectionChange", event);
    // console.log(this.selectedOrderDirection);
  }

  setDefaultOrSelectedValues() {
    switch (this.sortService.currentPageName) {
      case SearchPageNames.CustomerSearch: {
          this.selectedDropdownValue = this.sortService.customerSortValue;
          this.selectedOrderDirection = this.sortService.customerDirectionValue;
          break;
        }
      case SearchPageNames.CustomerDetailsSearch: { break; }
      case SearchPageNames.ProductSearch: {
          this.selectedDropdownValue = this.sortService.productSortValue == '' ? 'Bestmatch' : this.sortService.productSortValue;
          this.selectedOrderDirection = this.sortService.productDirectionValue;
          break;
        }
      case SearchPageNames.ProductDetailsSearch: { break; }
      case SearchPageNames.BinLocationProductSearch: { break; }
      case SearchPageNames.SuppliersSearch: {
          this.selectedDropdownValue = this.sortService.supplierSortValue;
          this.selectedOrderDirection = this.sortService.supplierDirectionValue;
          break;
        }
      case SearchPageNames.CustomerAddressSearch: {
          this.selectedDropdownValue = this.sortService.customerAddressSortValue;
          this.selectedOrderDirection = this.sortService.customerAddressDirectionValue;
          break;
        }
      case SearchPageNames.DashboardContactSearch: {
          this.selectedDropdownValue = this.sortService.dashboardConatctSortValue;
          this.selectedOrderDirection = this.sortService.dashboardConatctDirectionValue;
          break;
        }
      case SearchPageNames.CustomerContactSearch: {
          this.selectedDropdownValue = this.sortService.customerConatctSortValue;
          this.selectedOrderDirection = this.sortService.customerConatctDirectionValue;
          break;
        }
      case SearchPageNames.DashboardDocumentsSearch: { break; }

      case SearchPageNames.CustomerNotepad: {
          this.selectedDropdownValue = this.sortService.customerNotepadSortValue;
          this.selectedOrderDirection = this.sortService.customerNotepadDirectionValue;
          break;
        }
      case SearchPageNames.DashboardNotepadSearch: {
          this.selectedDropdownValue = this.sortService.dashboardNotepadSortValue;
          this.selectedOrderDirection = this.sortService.dashboardNotepadDirectionValue;
          break;
        }
      case SearchPageNames.DashboardAddressSearch: {
          this.selectedDropdownValue = this.sortService.dashboardAddressSortValue;
          this.selectedOrderDirection = this.sortService.dashboardAddressDirectionValue;
          break;
        }
      case SearchPageNames.CustomerProductsPurchased: {
          this.selectedDropdownValue = this.sortService.customerProductsPurchasedSortValue;
          this.selectedOrderDirection = this.sortService.customerProductsPurchasedDirectionValue;
          break;
        }
      case SearchPageNames.CustomerOpportunity: {
          this.selectedDropdownValue = this.sortService.customerOpportunitySortValue;
          this.selectedOrderDirection = this.sortService.customerOpportunityDirectionValue;
          break;
        }
      case SearchPageNames.DashboardOpportunitySearch: {
          this.selectedDropdownValue = this.sortService.dashboardOpportunitySortValue;
          this.selectedOrderDirection = this.sortService.dashboardOpportunityDirectionValue;
          break;
        }
      case SearchPageNames.CustomerOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.selectedDropdownValue = this.sortService.dashboardOrderSortValue;
            this.selectedOrderDirection = this.sortService.dashboardOrderDirectionValue;
          } else {
            this.selectedDropdownValue = this.sortService.customerOrderSortValue;
            this.selectedOrderDirection = this.sortService.customerOrderDirectionValue;
          }
          break;
        }
      case SearchPageNames.CustomerQuotes: {
          if (this.faDocumentService.fromDashbard) {
            this.selectedDropdownValue = this.sortService.dashboardQuoteSortValue;
            this.selectedOrderDirection = this.sortService.dashboardQuoteDirectionValue;
          } else {
            this.selectedDropdownValue = this.sortService.customerQuoteSortValue;
            this.selectedOrderDirection = this.sortService.customerQuoteDirectionValue;
          }
          break;
        }
      case SearchPageNames.CustomerTempOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.selectedDropdownValue = this.sortService.dashboardTempOrderSortValue;
            this.selectedOrderDirection = this.sortService.dashboardTempOrderDirectionValue;
          } else {
            this.selectedDropdownValue = this.sortService.customerTempOrderSortValue;
            this.selectedOrderDirection = this.sortService.customerTempOrderDirectionValue;
          }
          break;
        }
      case SearchPageNames.CustomerCredit: {
          if (this.faDocumentService.fromDashbard) {
            this.selectedDropdownValue = this.sortService.dashboardCreditSortValue;
            this.selectedOrderDirection = this.sortService.dashboardCreditDirectionValue;
          } else {
            this.selectedDropdownValue = this.sortService.customerCreditSortValue;
            this.selectedOrderDirection = this.sortService.customerCreditDirectionValue;
          }
          break;
        }
      case SearchPageNames.CustomerInvoices: {
          if (this.faDocumentService.fromDashbard) {
            this.selectedDropdownValue = this.sortService.dashboardInvoicesSortValue;
            this.selectedOrderDirection = this.sortService.dashboardInvoicesDirectionValue;
          } else {
            this.selectedDropdownValue = this.sortService.customerInvoicesSortValue;
            this.selectedOrderDirection = this.sortService.customerInvoicesDirectionValue;
          }
          break;
        }
      case SearchPageNames.CustomerStatements: {
          if (this.faDocumentService.fromDashbard) {
            this.selectedDropdownValue = this.sortService.dashboardStatementSortValue;
            this.selectedOrderDirection = this.sortService.dashboardStatementDirectionValue;
          } else {
            this.selectedDropdownValue = this.sortService.customerStatementSortValue;
            this.selectedOrderDirection = this.sortService.customerStatementDirectionValue;
          }
          break;
        }
      case SearchPageNames.DashboardStockTranferSearch: {
          this.selectedDropdownValue = this.sortService.dashboardStockSortValue;
          this.selectedOrderDirection = this.sortService.dashboardStockDirectionValue;
          break;
        }
      default: { break; }
    }
  }
}
